import { makeListRequest } from '@/business/apiTreatment/request/makeQueryParams';
import { baseParams } from '@/business/apiTreatment/request/queryParamsUtils';
import UserExchangesService from '@/services/services/userexchanges.service';
import CrudModule from '@/store/crudModule';

/**
 * Business function. make query newItem function for API call.
 * @returns {{group_id: *}} The makeQueryParams function.
 */
const makeCreateParams = ({ rootGetters, item }) => {
  const newItem = baseParams({ rootGetters, item });
  newItem.authors = item.author_idx.map((id) => {
    return { author_id: id };
  });
  delete newItem.author_idx;
  return newItem;
};

const makeUpdateParams = ({ item, rootGetters }) => {
  const newItem = baseParams({ rootGetters, item });
  newItem.authors = item.author_idx.map((id) => {
    return { author_id: id };
  });
  delete newItem.author_idx;
  if (!newItem.logbook_entry_id) delete newItem.logbook_entry_id;
  return { newItem };
};

export default new CrudModule({
  serviceAPI: UserExchangesService,
  makeQueryParams: makeListRequest({ limitItemsRequest: 100 }),
  makeHttpParamsUrl: (id) =>
    `${process.env.MYPREDITY_BASE_URI}/actions/${id}/user_exchanges`,
  makeCreateParams,
  updateUrl: `${process.env.MYPREDITY_BASE_URI}/actions/user_exchanges`,
  makeUpdateParams,
});
